export const lyric06 = `Count up your portions, count up your checks
Feeding your fam while you're coming at my neck
When ya gonna freeze with the cruel dramatics?
I'm not inspired by your foolish practice
Butter your bullshit, set up your fence
I'm just the chicken giving you the egg
Soon you're gonna see that your breath was wasted
Don't speak too soon on your doubts, you're making
A big deal out of a little thing
Why should I try to conform to formulated paths?
When clearly all my instincts led to something more magical?
Am I just a number? 'Cause it seems like that's your goal
You push us past our limits just to watch decimals grow
Oh, I need a reason why I'm looked at like a joke
Until I prove you wrong like I've done time and time before
And all your idle teaching and your criticism lack
The potential to penetrate my solid golden path
To decide what my future is, I'm my own clairvoyant
There's no controlling me
Imagination on ascend
Take me to Venus, let me explode
I'm ready to pop like a volcano
Jump over me like you're playing hot lava
Emotions on one hundred thousand, who's gonna
Shake me like soda creme, but, of course
Use all your words to distract from the source
Of where all the growth on the paper happens
Leave me alone in my own concoction
Pricking all my fingertips to carve out many roads
Pushing out the petals from the bud of what I know
Am I just a number? 'Cause it seems like that's your goal
You push us past our limits just to watch decimals grow
Oh, I need a reason why I'm looked at like a joke
Until I prove you wrong like I've done time and time before
And all my intuition says is, "Expansion comes first"
But not just by material, I'm talking 'bout in here
My heart space and my cranium must be loved too, my dear
Don't push me to the edge until I'm useless and can't feel
They replaced their search for knowledge
With the reach of many material gains
They lack the tenderness of the sensitive
Empathetic bodies crying from the pain
It's too late to grow their frame
Of mind it seems that it's already made
No use in arguing with someone who doesn't
Wanna prioritize birthing of creation
Am I just a number?
Am I just a number?
Am I just a number?
Am I just a number?
Am I just a number? 'Cause it seems like that's your goal
You push us past our limits just to watch our numbers grow
Oh, I need a reason why I'm looked at like a joke
Until I prove you wrong which I've done time and time before
And all my intuition says is, "Expansion comes first"
But not just by material I'm talking 'bout in here
My heart space and my cranium must be loved too, my dear
Don't push me to the edge until I'm useless and can't feel`